// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__-2cOW","content":"GlobalSearch_content__1CSNO"};